module.exports = __webpack_public_path__ + "static/media/04.Akd.Prog Photo.2a3dd538.JPG";